export default {
  LOGIN: '/login',
  IDP_LOGIN: '/idp_login',
  CLASSIC_LOGIN: '/classic_login',
  OKTA_LOGIN: '/login_v2',
  UPLOADER: '/uploader',
  ANNOTATOR: '/annotator',
  VIDEA_INSIGHT: '/videa_insight',
  VIDEA_INSIGHT_DASHBOARD: '/videa_insight',
  VIDEA_INSIGHT_LOCATIONS: '/videa_insight/locations',
  VIDEA_INSIGHT_LOCATION_DETAILS: '/videa_insight/locations/:id',
  CLAIM_SUMMARY: '/claim_summary',
  SWITCHBOARD: '/switchboard',
  INSIGHTS: '/insights',
  ENGAGEMENT: '/engagement',
  PRACTICE_GROUPS: '/practice_groups',
  EXTERNAL: '/external',
  EXTERNAL_VISIT_SIDEBAR: '/external-visit-sidebar',
  EXTERNAL_MODAL: '/external-modal',
  LANDING_PAGE: '/landing_page',
  UNAUTHORIZED: '/unauthorized',
  ERROR: '/error',
  PATIENT_MATCH_ERROR: '/patient_match_error',
  ABOUT: '/about',
  MAGIC: '/magic',
  PATIENT_DOWNLOADABLE: '/patient-downloadable',
  ANALYTICS: '/analytics',
  ONBOARDING: '/onboarding',
  HISTORICAL: '/process_historical',
  CLAIMS: '/claims',
  AUTOVERIFY: '/auto-verify',
  PATIENT_BENEFITS: '/auto-verify/patient/:patientId/benefits',
  CONNECT_PAYERS: '/auto-verify/connect-payers',
  PRACTICE_CONFIGURATION_SETTINGS: '/auto-verify/connect-payers/settings',
  AMBIENT: '/ambient',
  INSURANCE_EXPORT: '/insurance_export',
  TRIAL: '/trial',
  VISIT_SIDEBAR: '/visit-sidebar',
  PUBLIC: '/public',
  PARSE_SHORT_CODE: '/parse-short-code',
  REFERRALS: '/referrals',
} as const;

export const envToSalesDemoAccount = {
  local: {
    primaryOrganizationId: '', // Default Dev Org
    primaryPracticeId: '6217dc7a04809c1afd525a78', // Videa Dev Default Practice
  },
  development: {
    primaryOrganizationId: '', // Default Dev Org
    primaryPracticeId: '6217dc7a04809c1afd525a78', // Videa Dev Default Practice
  },
  staging: {
    primaryOrganizationId: '63d11c918de54b87ae5a180c', // Sales Demo - Stg
    primaryPracticeId: '63d11cbd8de54b87ae5a181d', // VideaHealth's Staging Dental Dream
  },
  production: {
    primaryOrganizationId: '62c44f97c1ecaa68cdd7cbc1', // Sales Demo Organization
    primaryPracticeId: '63c8177278fdd98bc4597346', // VideaHealth Dental Dream
  },
};
